import React, { createContext, useContext, useMemo } from 'react';

export interface AuthTokenContextType {
  authToken: string;
  authError: boolean;
}

export const AuthTokenContext = createContext<AuthTokenContextType | undefined>(undefined);

export function useAuthTokenContext() {
  const ctx = useContext(AuthTokenContext);
  if (!ctx) throw new Error('useAuthTokenContext must be used within AuthTokenProvider');
  return ctx;
}
